const Checkbox = ({ name, options, onChange, checked, checkedValues }) => {
    return (
        <>
            {options.map((option) => (
                <li key={option.id} className="item-checkBox">
                    <input
                        type="checkbox"
                        id={option.id}
                        name={name}
                        value={option.value}
                        onChange={onChange}
                        checked={
                            checkedValues
                                ? checkedValues.includes(option.value)
                                : Array.isArray(checked?.[name]) && checked[name].includes(option.value)
                        }
                    />
                    <span />
                    <label htmlFor={option.id}>
                        <span className={option.classText}>{option.label}</span> {options.total}
                    </label>
                </li>
            ))}
        </>
    );
};

export default Checkbox;
